module.exports = __webpack_public_path__ + "static/media/fixed-voice-copy-paste.a6bef80e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed-voice-copy-paste.svg
// module id = 3184
// module chunks = 0